import { InMemoryCache } from '@apollo/client';
// Type policies for Apollo cache
export const createTuneddCache = () => {
  return new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          listCases: {
            keyArgs: false,
            // Merge policy for pagination if needed
            merge(existing, incoming) {
              return incoming;
            },
          },
          listGroups: {
            keyArgs: ['filter', 'limit'],
          },
          listChats: {
            keyArgs: ['filter', 'limit'],
          },
          getCase: {
            keyArgs: ['input'],
          },
          getUser: {
            keyArgs: false,
          },
          isFitScoreCompleted: {},
        },
      },
      Case: {
        keyFields: ['id'],
      },
      Group: {
        keyFields: ['id'],
      },
      ChatMessageConnection: {
        fields: {
          items: {
            merge(existing = [], incoming) {
              const existingIds = existing.map((msg: any) => msg.id);
              const newMessages = incoming.filter((msg: any) => !existingIds.includes(msg.id));
              return [...existing, ...newMessages];
            },
          },
        },
      },
    },
  });
};
